import { Box, Card, Flex, Header, styled, Text } from '@driftt/dds'

export const StyledCard = styled(Card, {
  width: '100%',
  maxWidth: '810px',
  padding: '$3',
})

export const StyledCardContent = styled(Flex, {
  padding: '$7 $8',
  width: '85%',
  margin: '0 auto',
})

export const StyledIconContainer = styled(Box, {
  marginBottom: '16px',
})

export const StyledHeader = styled(Header, {
  textAlign: 'center',
})

export const StyledText = styled(Text, {
  textAlign: 'center',
})

export const StyledButtonContainer = styled(Box, {
  marginTop: '$3',
})
